window.ComplianceTrainingAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    var url = publicConfiguration.LMS_SERVERS;

    self.ON_COMPLIANCE = 'COMPLIANCE_TRAINING';
    self.START_COURSE = "NOT_STARTED";
    self.RESUME_COURSE = "STARTED";
    self.COMPLETED = "COMPLETED";
    self.NOT_COMPLETED = "NOT_COMPLETED";
    self.EXPIRED = "EXPIRED";

    self.getLearnerCourses = function () {
        var deferred = $q.defer();

        _protected.request(url + "courses/registrations", 'GET')
            .then(function (res) {
                    deferred.resolve(res.data);
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getRedirectURL = function (registrationId, languageCode) {
        var deferred = $q.defer();

        _protected.request(url + "courses/registrations/" + registrationId + "/launch", 'GET', {
            redirect_url: location.protocol + "//" + location.host + "/lms-scrom-close",
            language: languageCode,
        })
            .then(function (res) {
                    deferred.resolve(res.data.data.registration_launch);
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getCourseCertificate = function (registrationId) {
        var deferred = $q.defer();

        _protected.request(url + "courses/registrations/" + registrationId + "/certificate", 'GET')
            .then(function (res) {
                    if (res && res.data && res.data.data && res.data.data.certificate && res.data.data.certificate.path) {
                        deferred.resolve(res.data.data.certificate.path);
                    } else {
                        deferred.reject(null);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    }

});
